import {createAsyncThunk} from '@reduxjs/toolkit';

import {ILookupEntry} from 'shared/types/lookups';

import {
    IGetExternalSystemsForUserArgs,
    IPostExternalSystemsForUserArgs,
    getAvailableExternalSystemsForUser,
    getExternalSystemsForUser,
    getUseExternalSystemsPropertyFlag,
    postExternalSystemsForUser,
} from './external-systems-slice-api';
import {EXTERNAL_SYSTEMS_SLICE} from './external-systems-slice-constants';
import {IExternalSystemUserMappingDto} from './external-systems-slice-types';

export const loadAllExternalSystemsDataForUser = createAsyncThunk<
{
    externalSystems: IExternalSystemUserMappingDto[];
    availableExternalSystems: ILookupEntry[];
}, IGetExternalSystemsForUserArgs
>(
    `${EXTERNAL_SYSTEMS_SLICE}/loadAllExternalSystemsDataForUser`,
    async (args, {rejectWithValue}) => {
        try {
            const [
                externalSystemsResponse,
                availableExternalSystemsResponse,
            ] = await Promise.all([
                getExternalSystemsForUser(args),
                getAvailableExternalSystemsForUser(args),
            ]);

            return {
                availableExternalSystems: availableExternalSystemsResponse.data,
                externalSystems: externalSystemsResponse.data,
            };
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadExternalSystemsForUser = createAsyncThunk<
    IExternalSystemUserMappingDto[], IGetExternalSystemsForUserArgs
>(
    `${EXTERNAL_SYSTEMS_SLICE}/loadExternalSystemsForUser`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getExternalSystemsForUser(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadAvailableExternalSystemsForUser = createAsyncThunk<
    ILookupEntry[], IGetExternalSystemsForUserArgs
>(
    `${EXTERNAL_SYSTEMS_SLICE}/loadAvailableExternalSystemsForUser`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getAvailableExternalSystemsForUser(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const saveExternalSystemsForUser = createAsyncThunk<
    string, IPostExternalSystemsForUserArgs
>(
    `${EXTERNAL_SYSTEMS_SLICE}/saveExternalSystemsForUser`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await postExternalSystemsForUser(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadUseExternalSystemsPropertyFlag = createAsyncThunk<
'Y' | 'N'
>(
    `${EXTERNAL_SYSTEMS_SLICE}/loadUseExternalSystemsPropertyFlag`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getUseExternalSystemsPropertyFlag();
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
